var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96026 0H1.84768C0.834437 0 0 0.834437 0 1.84768V16.1523C0 17.1656 0.834437 18 1.84768 18H5.96026C6.97351 18 7.80795 17.1656 7.80795 16.1523V1.84768C7.83775 0.834437 7.00331 0 5.96026 0ZM6.49669 16.1523C6.49669 16.4503 6.25828 16.6887 5.96026 16.6887H1.84768C1.54967 16.6887 1.31126 16.4503 1.31126 16.1523V1.84768C1.31126 1.54967 1.54967 1.31126 1.84768 1.31126H5.96026C6.25828 1.31126 6.49669 1.54967 6.49669 1.84768V16.1523Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1526 0H12.0401C11.0268 0 10.1924 0.834437 10.1924 1.84768V5.96026C10.1924 6.97351 11.0268 7.80795 12.0401 7.80795H16.1526C17.1659 7.80795 18.0003 6.97351 18.0003 5.96026V1.84768C18.0003 0.834437 17.1659 0 16.1526 0ZM16.6891 5.96026C16.6891 6.25828 16.4507 6.49669 16.1526 6.49669H12.0401C11.7421 6.49669 11.5036 6.25828 11.5036 5.96026V1.84768C11.5036 1.54967 11.7421 1.31126 12.0401 1.31126H16.1526C16.4507 1.31126 16.6891 1.54967 16.6891 1.84768V5.96026Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1526 10.1623H12.0401C11.0268 10.1623 10.1924 10.9967 10.1924 12.0099V16.1523C10.1924 17.1656 11.0268 18 12.0401 18H16.1526C17.1659 18 18.0003 17.1656 18.0003 16.1523V12.0397C18.0003 10.9967 17.1659 10.1623 16.1526 10.1623ZM16.6891 16.1523C16.6891 16.4503 16.4507 16.6888 16.1526 16.6888H12.0401C11.7421 16.6888 11.5036 16.4503 11.5036 16.1523V12.0397C11.5036 11.7417 11.7421 11.5033 12.0401 11.5033H16.1526C16.4507 11.5033 16.6891 11.7417 16.6891 12.0397V16.1523Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c4cac086c0ef9b381ea85f67002b7339.svg";
export { ForwardRef as ReactComponent };